module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Demi.19191f36.woff2";